var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"demo",staticClass:"demo",staticStyle:{"display":"none"},on:{"scroll":_vm.onTimelineScroll}},[_c('div',{staticClass:"line"},[_c('div',{ref:"intro",staticClass:"intro"},[_c('div',{ref:"mp",staticClass:"mixpoint"})]),_c('div',{ref:"outro",staticClass:"outro"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }